import { gql } from "@apollo/client"

export const UpdateCoupon = gql`
mutation UpdateCoupon($idClient: ID!, $content: contentCoupon!) {
  updateCoupon(idClient: $idClient, content: $content) {
    status
  }
}
`